// extracted by mini-css-extract-plugin
export default {"root":"register_form_root__X6Qg6","App":"register_form_App__-XV4L","register-card":"register_form_register-card__mqvth"};